import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthGuard } from './_guards';
import { AuthenticationService } from './_services';
import { HomeComponent } from './home/home.component';

import { FooterComponent } from './_footer/_footer.component';
import { HeaderComponent } from './_header/_header.component';
import { LoginComponent } from './login/login.component';
import { NavigationComponent } from './navigation/navigation.component';
import { AgenciesListComponent } from './agencies-list/agencies-list.component';
import { AgencyPageComponent } from './agency-page/agency-page.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ContactComponent } from './contact/contact.component';
import { MyBookmarksComponent } from './my-bookmarks/my-bookmarks.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { MyPropertiesComponent } from './my-properties/my-properties.component';
import { PricingTablesComponent } from './pricing-tables/pricing-tables.component';
import { SubmitPropertyComponent } from './submit-property/submit-property.component';
import { TitleBarComponent } from './title-bar/title-bar.component';
import { Globals } from 'src/shared/globals';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { RegistrationComponent } from './registration/registration.component';
import { EventEmitterService } from '../global_services/event-emitter.service';
import { PreviousRouteGuard } from './_guards/PreviousRouteGuard';
import { PreviousRouteService } from '../global_services/PreviousRouteService';
import { NgxPaginationModule } from 'ngx-pagination';
import { httpInterceptorProviders } from './http-interceptors';
import { HttpCancelService } from './http-interceptors/http-cancel-service.service';
import { ToasterService } from './_services/toaster.service';
import { ApproveComponent } from './property/approve/approve.component';
import { RejectComponent } from './property/reject/reject.component';
import { PropertiesComponent } from './Properties/Properties.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { PropertyDetailsComponent } from './property-details/property-details.component';
import { ProfileEditComponent } from './Profile/profile-edit/profile-edit.component';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { InformationComponent } from './registration/information/information.component';
import { ConfirmationComponent } from './registration/confirmation/confirmation.component';
import { HomeListingComponent } from './home-listing/home-listing.component';
import { PropertyListingComponent } from './property-listing/property-listing.component';
import { MyPropertiesListingComponent } from './my-properties-listing/my-properties-listing.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { ContactsComponent } from './marketing/contacts/contacts.component';
import { QuillModule } from 'ngx-quill';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    LoginComponent,
    NavigationComponent,
    AgenciesListComponent,
    AgencyPageComponent,
    ChangePasswordComponent,
    ContactComponent,
    PropertiesComponent,
    MyBookmarksComponent,
    MyProfileComponent,
    MyPropertiesComponent,
    PricingTablesComponent,
    PropertyDetailsComponent,
    SubmitPropertyComponent,
    TitleBarComponent,
    ForgetPasswordComponent,
    RegistrationComponent,
    ApproveComponent,
    RejectComponent,
    PrivacyPolicyComponent,
    AboutUsComponent,
    ProfileEditComponent,
    InformationComponent,
    ConfirmationComponent,
    HomeListingComponent,
    PropertyListingComponent,
    MyPropertiesListingComponent,
    SpinnerComponent,
    ContactsComponent,
    TermsAndConditionsComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    NgSelectModule,
    NgxPaginationModule,
    QuillModule.forRoot()
  ],
  providers: [
    ToasterService,
    HttpCancelService,
    httpInterceptorProviders,
    AuthGuard,
    PreviousRouteGuard,
    AuthenticationService,
    Globals,
    EventEmitterService,
    PreviousRouteService,
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    provideHttpClient(withInterceptorsFromDi()),
    provideClientHydration(withEventReplay())
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
